/**
 * Returns a shallow copy of `obj` with all keys whose value is `undefined`
 * removed.  Safe to use in Firestore `addDoc` payloads where `deleteField()`
 * sentinels must not appear.
 */
export function omitUndefined<T extends object>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined),
  ) as Partial<T>
}
